import { render, staticRenderFns } from "./liangxiang-report.vue?vue&type=template&id=299ac1ee&scoped=true"
import script from "./liangxiang-report.vue?vue&type=script&lang=js"
export * from "./liangxiang-report.vue?vue&type=script&lang=js"
import style0 from "./liangxiang-report.vue?vue&type=style&index=0&id=299ac1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299ac1ee",
  null
  
)

export default component.exports